<script setup lang="ts">
import InviteRegisterForm from '@/v2/shared/components/auth/InviteRegisterForm.vue'
import AuthLayout from '@/v2/shared/layouts/auth/AuthLayout.vue'
import { Link } from '@inertiajs/vue3'
import { route } from 'ziggy-js'

defineProps<{
    email: string
    status?: string
}>()
</script>

<template>
    <AuthLayout title="Accept Invite">
        <template #header-action>
            Already have an account?
            <Link
                :href="route('login')"
                class="underline decoration-from-font underline-offset-2"
            >
                Log in
            </Link>
        </template>

        <InviteRegisterForm :email="email" :status="status" />
    </AuthLayout>
</template>
